import { render, staticRenderFns } from "./DanhSachCapDonVi.vue?vue&type=template&id=348308bc&"
import script from "./DanhSachCapDonVi.vue?vue&type=script&lang=js&"
export * from "./DanhSachCapDonVi.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachCapDonVi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports